'use client'

import { liteClient as algoliasearch } from 'algoliasearch/lite'
import { InstantSearchNext } from 'react-instantsearch-nextjs'
import { Configure } from 'react-instantsearch'

import EventsCalendar from '@/components/events-calendar/EventsCalendar'

import type { FilterPropsType } from '@/layouts/types'

type GridProps = {
  filters?: FilterPropsType
  pillFilter?: string
}

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY,
)

export default function EventsCalendarWrapper({ filters, pillFilter }: GridProps): JSX.Element {
  return (
    <InstantSearchNext
      searchClient={searchClient}
      indexName={`wp_posts_all-events`}
      routing
      future={{
        preserveSharedStateOnUnmount: true,
        persistHierarchicalRootCount: true,
      }}>
      <Configure hitsPerPage={1000} />

      <EventsCalendar filters={filters} pillFilter={pillFilter} />
    </InstantSearchNext>
  )
}
